import jss from 'jss'
import preset from 'jss-preset-default'

export function setPaddingSection(defaultObj, responsive, element) {
    let {top,bottom} = defaultObj;
    jss.setup(preset())
    const styles = {
        padding:{}
    }
    if(typeof top != 'undefined') {
        styles['padding']['padding-top'] = top;
    }
    if(typeof bottom != 'undefined') {
        styles['padding']['padding-bottom'] = bottom;
    }

    if(responsive) {
        responsive = JSON.parse(responsive);
        responsive.forEach(function(item) {
            let padding_css = {};
            let {paddingTop,paddingBottom} = item;

            if(typeof paddingTop !== 'undefined') padding_css['padding-top'] = paddingTop;
            if(typeof paddingBottom !== 'undefined') padding_css['padding-bottom'] = paddingBottom;
            styles[`@media (max-width: ${item.breakpoint}px)`] = {
                padding : padding_css
            };
        })
    }

    const {classes} = jss.createStyleSheet(styles).attach()
    element.classList.add(classes.padding);
}